import { render, staticRenderFns } from "./pptx.vue?vue&type=template&id=8d0788d2&scoped=true&"
import script from "./pptx.vue?vue&type=script&lang=js&"
export * from "./pptx.vue?vue&type=script&lang=js&"
import style0 from "./pptx.vue?vue&type=style&index=0&id=8d0788d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0788d2",
  null
  
)

export default component.exports